import React, { FC, ReactNode, useCallback, useMemo } from "react";
import { useListener, useService, useUpdate } from "../react";
import { MutableComponentRegistry } from "./mutable-component-registry";


export function MutableComponent({ component, props }: MutableComponent.Props): ReactNode
{
    const registry = useService(MutableComponentRegistry);
    const context = useMemo(() => ({ component: registry.resolve(component) }), [component]);
    const update = useUpdate();

    const onUpdate =
        useCallback(
            () =>
            {
                const $component = registry.resolve(component);
                if ($component != component)
                {
                    context.component = $component;
                    update();
                }
            },
            [component]
        );

    useListener(registry, "componentUpdate", onUpdate);

    return React.createElement(context.component, props ?? {});
};

export namespace MutableComponent
{
    export function make<T extends FC>(component: T): T;
    export function make(component: FC): FC
    {
        return (props => MutableComponent({ component, props }));
    }

    export interface Props
    {
        component: React.FC;
        props?: {};
    }
}
